import PageCard from '@/components/general/PageCard';
import React from 'react';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';

export default function ContactusInfo() {
  const list = [
    {
      id: 1,
      title: 'نشانی دفتر مرکزی',
      text: 'سعادت آباد، میدان فرهنگ، بلوار محمدعلی کشاورز، نبش چهارم شرقی، پلاک29، واحد204',
      icon: <MainIcons.locationIcon fill="var(--danger)" />,
      backgroundIcon: 'var(--danger-bg)',
    },
    {
      id: 2,
      title: 'ایمیل',
      text: 'support@cara-app.ir',
      icon: <MainIcons.emailIcon fill="var(--brand-deep)" />,
      backgroundIcon: 'var(--tag-bg)',
    },
    {
      id: 3,
      title: 'تلفن پشتیبانی',
      text: '021-91036006',
      icon: <MainIcons.phoneIcon fill="var(--purple)" />,
      backgroundIcon: 'var(--purple-bg)',
    },
    {
      id: 4,
      title: 'ساعات پاسخگویی',
      text: 'شنبه تا پنجشنبه، ۹ صبح تا ۹ شب',
      icon: <MainIcons.clockIcon fill="var(--green)" />,
      backgroundIcon: 'var(--green-bg)',
    },
  ];
  return (
    <div className={`${styles.list}`}>
      {list?.map((item, index) => (
        <PageCard
          key={index}
          title={item?.title}
          text={item?.text}
          icon={item?.icon}
          backgroundIcon={item?.backgroundIcon}
          className={`${styles.card}`}
          headClass={`${styles.headClass}`}
          textClass={styles.textClass}
          titleClass={styles.titleClass}
          iconClass={`${styles.iconClass}`}
        />
      ))}
    </div>
  );
}
